/**
 * Třída reprezentující generickou dvojici
 */
export class Tuple<TOne, TTwo> {
    constructor(one?: TOne, two?: TTwo) {
        this._one = one;
        this._two = two;
    }

    private _one?: TOne;
    public get one(): TOne | undefined {
        return this._one;
    }
    public set one(v: TOne | undefined) {
        this._one = v;
    }

    private _two?: TTwo;
    public get two(): TTwo | undefined {
        return this._two;
    }
    public set two(v: TTwo | undefined) {
        this._two = v;
    }
}

/**
 * Třída reprezentující generickou trojici
 */
export class Triplet<TOne, TTwo, TThree> extends Tuple<TOne, TTwo> {
    constructor(one?: TOne, two?: TTwo, three?: TThree) {
        super(one, two);

        this._three = three;
    }

    private _three?: TThree;
    public get three(): TThree | undefined {
        return this._three;
    }
    public set three(v: TThree | undefined) {
        this._three = v;
    }
}
